import React, { useState, useEffect } from 'react';
import {
  Card, Form, Input, Button, Select, DatePicker, TimePicker,
  Table, Typography, Divider, message, Tabs, Tag, Space, Row, Col
} from 'antd';
import { SendOutlined, HistoryOutlined } from '@ant-design/icons';
import moment from 'moment';
import notificationService from '../services/notificationService';
import { FACTORY_API, TENANT_API, CONTRACT_API } from '../constants/api';
import axios from '../services/axiosConfig';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const { Title, Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

// Hàm chuyển đổi số thành chữ
const convertNumberToWords = (number) => {
  const units = ['', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];
  const teens = ['mười', 'mười một', 'mười hai', 'mười ba', 'mười bốn', 'mười lăm', 'mười sáu', 'mười bảy', 'mười tám', 'mười chín'];
  const tens = ['', '', 'hai mươi', 'ba mươi', 'bốn mươi', 'năm mươi', 'sáu mươi', 'bảy mươi', 'tám mươi', 'chín mươi'];
  const scales = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ', 'tỷ tỷ'];

  if (number === 0) return 'Không';

  const convertLessThanThousand = (n) => {
    if (n === 0) return '';
    if (n < 10) return units[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) {
      const unit = n % 10;
      const ten = Math.floor(n / 10);
      return unit === 0 ? tens[ten] : unit === 1 ? `${tens[ten]} mốt` : unit === 5 ? `${tens[ten]} lăm` : `${tens[ten]} ${units[unit]}`;
    }
    const hundred = Math.floor(n / 100);
    const remainder = n % 100;
    return `${units[hundred]} trăm ${convertLessThanThousand(remainder)}`;
  };

  const convert = (n, scaleIndex) => {
    if (n === 0) return '';
    const remainder = n % 1000;
    const quotient = Math.floor(n / 1000);
    const scale = scales[scaleIndex];
    const remainderText = convertLessThanThousand(remainder);
    const quotientText = quotient > 0 ? convert(quotient, scaleIndex + 1) : '';
    return `${quotientText} ${remainderText} ${scale}`.trim();
  };

  const result = `${convert(number, 0)} đồng`;
  return result.charAt(0).toUpperCase() + result.slice(1);
};

const quillModules = {
  toolbar: [
    [{ 'font': [] }, { 'size': [] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'script': 'sub' }, { 'script': 'super' }],
    [{ 'header': 1 }, { 'header': 2 }, 'blockquote', 'code-block'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }, { 'align': [] }],
    ['link', 'image', 'video', 'formula'],
    ['clean']
  ]
};

function Notifications() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [sentNotifications, setSentNotifications] = useState([]);
  const [factories, setFactories] = useState([]);
  const [showHtml, setShowHtml] = useState(false);
  const [tenants, setTenants] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [notificationType, setNotificationType] = useState(null);
  const [templateValue, setTemplateValue] = useState('');
  const [formValues, setFormValues] = useState({});

  // Fetch factories and tenants on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // Fetch factories
        const factoryResponse = await axios.get(FACTORY_API.LIST);
        setFactories(factoryResponse.data.factories || []);

        // Fetch active contracts
        const contractsResponse = await axios.get(CONTRACT_API.GET_ACTIVE_CONTRACTS);
        const activeContracts = contractsResponse.data.data || [];
        setTenants(activeContracts);

        // Fetch notification history
        fetchNotificationHistory(1);
      } catch (error) {
        console.error('Error fetching initial data:', error);
        message.error('Không thể tải dữ liệu ban đầu');
      }
    };

    fetchInitialData();
  }, []);

  const contractTemplate = `<p>Công ty CP VFI VN&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM&nbsp;</p><p><strong>Số:</strong> /CV.VFI/2021&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Độc lập – Tự do – Hạnh phúc</strong></p><p><strong><em>V/v: Tăng giá thuê xưởng từ Tháng 07/2022 – 06/2023</em></strong> &nbsp;&nbsp;&nbsp;Long An, ngày <u>20</u> tháng <u>06</u> năm 2022</p><p><strong><u>Kính gửi:</u> {{recipients}}</strong></p><p>Lời đầu tiên, <strong>Công Ty CP VFI VN</strong> xin chân thành cảm ơn quý khách hàng đã tin tưởng</p><a>và hợp tác với Công Ty chúng tôi.</a><ul><li>Căn cứ hợp đồng thuê xưởng số {{contractId}} ký ngày {{signDate}};</li><li>Căn cứ chỉ số CPI tháng {{cpiPeriod}} (Nguồn Tổng Cục Thống Kê Việt Nam).</li></ul><a>Chúng tôi xin thông báo đến Quý Công ty về việc áp dụng mức giá cho thuê xưởng tại:</a><ul><li><strong>Nhà xưởng:</strong> {{factoryName}}</li><li>Giá thuê (chưa VAT):<strong> <span style="color: rgb(0, 0, 0);">{{currentRentAmount}} VNĐ/tháng.</span></strong></li></ul><a><em> </em>		<em>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({{newRentAmountInWords}})</em></a><ul><li>Thời gian áp dụng:&nbsp;<strong><em>{{applyPeriod}}</em></strong></li></ul><p><strong>Ghi chú:</strong> Giá thuê (chưa VAT) Tháng {{currentPeriod}}&nbsp;&nbsp;&nbsp;= {{currentRentAmount}} VNĐ</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CPI (<span style="color: rgb(0, 0, 0);">tăng {{cpiIncrease}}% + 2% </span>)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        = <u>{{increaseAmount}} VNĐ</u></p><p><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{newRentAmount}} VNĐ</strong></p> <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Trân trọng Thông báo</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;     <strong>CTY CP VFI VN</strong></p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<em>TRẦN THỊ CẨM NHUNG</em></p>`;

  // Tạo hàm async để xử lý hợp đồng
  const processContractData = async (values, activeContracts) => {
    try {
      const selectedContracts = activeContracts.filter(c => values.factoryIds?.includes(c.FactoryID));
      const tenantNames = [...new Set(selectedContracts.map(c => c.Tenant?.TenantName || ''))].join(', ');
      
      const firstContract = selectedContracts[0] || {};
      const increaseAmount = Math.round((firstContract.RentAmount || 0) * (((firstContract.YearlyIncreaseRate || 0) + 2) / 100));
      const newRentAmount = Math.round((firstContract.RentAmount || 0) + increaseAmount);
      const newRentAmountInWords = convertNumberToWords(firstContract.RentAmount || 0);

      const formattedValues = {
        recipients: tenantNames,
        contractId: firstContract.ContractID || '',
        signDate: firstContract.SignDate ? moment(firstContract.SignDate).format('DD/MM/YYYY') : '',
        factoryName: firstContract.Factory?.FactoryName || '',
        currentRentAmount: firstContract.RentAmount?.toLocaleString('vi-VN') || '0',
        newRentAmount: newRentAmount?.toLocaleString('vi-VN') || '0',
        newRentAmountInWords: newRentAmountInWords || '0',
        currentPeriod: values.currentPeriod || '03/2022- 06/2022',
        applyPeriod: values.applyPeriod || '07/2022- 06/2023',
        cpiPeriod: values.cpiPeriod || '03/2022- 06/2022',
        cpiIncrease: firstContract.YearlyIncreaseRate || 0,
        increaseAmount: increaseAmount?.toLocaleString('vi-VN') || '0'
      };

      return formattedValues;
    } catch (error) {
      console.error('Error processing contract data:', error);
      return {};
    }
  };

  useEffect(() => {
    const updateTemplate = async () => {
      if (formValues?.notificationType === 'contract') {
        console.log(formValues);
        try {
          const contractData = await processContractData(formValues, tenants);
          let notificationContent = contractTemplate;

          // Thay thế các placeholder trong template
          Object.entries(contractData).forEach(([key, value]) => {
            const placeholder = `{{${key}}}`;
            notificationContent = notificationContent.replace(new RegExp(placeholder, 'g'), value || '');
          });

          setTemplateValue(notificationContent);
          form.setFieldsValue({ template: notificationContent });
        } catch (error) {
          console.error('Error updating template:', error);
          message.error('Không thể cập nhật template');
        }
      }
    };

    updateTemplate();
  }, [formValues, tenants]);

  // Thêm hàm xử lý khi form thay đổi
  const handleFormChange = (changedValues, allValues) => {
    setFormValues(allValues);
  };

  // Fetch notification history
  const fetchNotificationHistory = async (pageNum, limit = 10) => {
    try {
      setHistoryLoading(true);
      const response = await notificationService.getCustomNotifications({
        page: pageNum,
        limit
      });

      // Cấu trúc dữ liệu API đã thay đổi, sử dụng response.data.data
      const notifications = response.data.data?.notifications || [];
      const total = response.data.data?.pagination?.total || 0;

      setSentNotifications(notifications);
      setTotal(total);
      setHistoryLoading(false);
    } catch (error) {
      console.error('Error fetching notification history:', error);
      message.error('Không thể tải lịch sử thông báo');
      setHistoryLoading(false);
    }
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      // Format date and time if provided
      let formattedValues = { ...values };

      if (values.scheduledDate) {
        formattedValues.scheduledDate = values.scheduledDate.format('YYYY-MM-DD');
      }

      if (values.scheduledTime) {
        formattedValues.scheduledTime = values.scheduledTime.format('HH:mm');
      }

      // Xử lý ngày bắt đầu và kết thúc nếu có
      if (values.holidayRange && values.holidayRange.length === 2) {
        formattedValues.startDate = values.holidayRange[0].format('YYYY-MM-DD');
        formattedValues.endDate = values.holidayRange[1].format('YYYY-MM-DD');
        delete formattedValues.holidayRange;
      }

      // Xử lý ngày trở lại làm việc
      if (values.returnDate) {
        formattedValues.returnDate = values.returnDate.format('YYYY-MM-DD');
      }
      // Send notification
      await notificationService.sendCustomNotification(formattedValues);

      message.success('Gửi thông báo thành công');
      form.resetFields();

      // Refresh notification history
      fetchNotificationHistory(1);

      setLoading(false);
    } catch (error) {
      console.error('Error sending notification:', error);
      message.error('Gửi thông báo thất bại');
      setLoading(false);
    }
  };

  // Hàm xử lý khi thay đổi loại thông báo
  const handleNotificationTypeChange = (value) => {
    setNotificationType(value);
    form.resetFields(['holidayRange', 'holidayName', 'returnDate', 'template']);
    if (value === 'contract') {
      setTemplateValue(contractTemplate);
      form.setFieldsValue({ template: contractTemplate });
    } else {
      setTemplateValue('');
      form.setFieldsValue({ template: '' });
    }
  };

  // Table columns for notification history
  const columns = [
    {
      title: 'Tiêu đề',
      dataIndex: 'Subject',
      key: 'subject',
      width: 250,
    },
    {
      title: 'Loại thông báo',
      dataIndex: 'Type',
      key: 'notificationType',
      width: 120,
      render: (type) => {
        let color = 'blue';

        if (type === 'power') color = 'red';
        if (type === 'water') color = 'orange';
        if (type === 'holiday') color = 'green';
        if (type === 'lunar') color = 'blue';
        if (type === 'contract') color = 'purple';

        return <Tag color={color}>{type === 'power' ? 'Cúp điện' : type === 'water' ? 'Cúp nước' : type === 'holiday' ? 'Nghỉ lễ' : type === 'lunar' ? 'Nghỉ tết' : type === 'contract' ? 'Tăng giá hợp đồng' : 'Không xác định'}</Tag>;
      }
    },
    {
      title: 'Người nhận',
      dataIndex: 'TenantID',
      key: 'recipients',
      width: 120,
      render: (tenantId) => {
        if (tenantId === 'all') return <Tag color="purple">Tất cả</Tag>;
        return <Tag color="blue">{tenantId}</Tag>;
      }
    },
    {
      title: 'Nhà xưởng',
      dataIndex: 'FactoryName',
      key: 'FactoryName',
      width: 100,
      render: (factoryName) => {
        if (!factoryName) return 'N/A';
        return <Tag color="green">{factoryName}</Tag>;
      }
    },
    {
      title: 'Ngày áp dụng',
      dataIndex: 'ScheduledDate',
      key: 'scheduledDate',
      width: 120,
      render: (date) => date ? moment(date).format('DD/MM/YYYY') : 'N/A'
    },
    {
      title: 'Thời gian',
      dataIndex: 'ScheduledTime',
      key: 'scheduledTime',
      width: 100,
      render: (time) => time || 'N/A'
    },
    {
      title: 'Thời lượng',
      dataIndex: 'Duration',
      key: 'duration',
      width: 100,
    },
    {
      title: 'Lý do',
      dataIndex: 'Reason',
      key: 'reason',
      width: 150,
      ellipsis: true,
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'CreatedAt',
      key: 'createdAt',
      width: 120,
      render: (date) => {
        if (!date) return '-';

        try {
          // Parse thời gian từ chuỗi ISO "2025-05-23T13:42:43.533Z"
          const dateStr = date.toString();

          if (dateStr.includes('T')) {
            // Xử lý format ISO: "2025-05-23T13:42:43.533Z"
            const [datePart, timePart] = dateStr.split('T');
            const timeOnly = timePart.split('.')[0]; // Bỏ milliseconds và Z

            const [year, month, day] = datePart.split('-');
            const [hour, minute] = timeOnly.split(':');

            // Format lại theo định dạng Việt Nam với thời gian UTC gốc
            return `${hour}:${minute} ${day}/${month}/${year}`;
          } else {
            // Xử lý format thường: "2025-05-23 13:42:43.533"
            const parts = dateStr.split(' ');
            if (parts.length >= 2) {
              const datePart = parts[0]; // "2025-05-23"
              const timePart = parts[1].split('.')[0]; // "13:42:43"

              const [year, month, day] = datePart.split('-');
              const [hour, minute] = timePart.split(':');

              return `${hour}:${minute} ${day}/${month}/${year}`;
            }
          }

          // Fallback về cách cũ nếu format khác
          const dateObj = new Date(date);
          return dateObj.toLocaleString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          });
        } catch (error) {
          console.error('Date parsing error:', error);
          return '-';
        }
      },
    }
  ];

  // Handle pagination change
  const handlePageChange = (pageNum) => {
    setPage(pageNum);
    fetchNotificationHistory(pageNum);
  };

  return (
    <div className="notifications-container" style={{ margin: '24px' }}>
      <Tabs defaultActiveKey="send">
        <TabPane
          tab={<span><SendOutlined /> Gửi thông báo</span>}
          key="send"
        >
          <Card>
            <Title level={4}>Gửi thông báo tùy chỉnh</Title>
            <Text type="secondary">
              Tạo và gửi thông báo tùy chỉnh đến khách hàng thuê nhà xưởng
            </Text>

            <Divider />

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              onValuesChange={handleFormChange}
            >
              <Form.Item
                name="factoryIds"
                label="Nhà xưởng"
                rules={[{ required: true, message: 'Vui lòng chọn nhà xưởng' }]}
              >
                <Select
                  placeholder="Chọn nhà xưởng"
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  mode="multiple"
                  style={{ width: '100%' }}
                >
                  <Option value="all">Tất cả nhà xưởng đang thuê</Option>
                  {tenants.map(contract => (
                    <Option key={contract.FactoryID} value={contract.FactoryID}>
                      {contract.Factory?.FactoryName || 'Không có xưởng'} - {contract.Tenant?.TenantName || 'Không có khách thuê'}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="subject"
                label="Tiêu đề thông báo"
                rules={[{ required: true, message: 'Vui lòng nhập tiêu đề' }]}
              >
                <Input placeholder="Nhập tiêu đề thông báo" />
              </Form.Item>

              <Form.Item
                name="notificationType"
                label="Loại thông báo"
                rules={[{ required: true, message: 'Vui lòng chọn loại thông báo' }]}
              >
                <Select
                  placeholder="Chọn loại thông báo"
                  onChange={handleNotificationTypeChange}
                >
                  <Option value="power">Thông báo cúp điện</Option>
                  <Option value="water">Thông báo cúp nước</Option>
                  <Option value="holiday">Thông báo nghỉ lễ</Option>
                  <Option value="lunar">Thông báo nghỉ tết</Option>
                  <Option value="contract">Thông báo tăng giá hợp đồng</Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="severity"
                label="Mức độ thông báo"
                initialValue="normal"
              >
                <Select placeholder="Chọn mức độ">
                  <Option value="normal">Thông thường</Option>
                  <Option value="urgent">Khẩn cấp</Option>
                </Select>
              </Form.Item>


              {(notificationType === 'power' || notificationType === 'water') && (
                <>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name="scheduledDate"
                        label="Ngày áp dụng"
                      >
                        <DatePicker style={{ width: '100%' }} placeholder="Chọn ngày áp dụng" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="scheduledTime"
                        label="Thời gian áp dụng"
                      >
                        <TimePicker
                          style={{ width: '100%' }}
                          placeholder="Chọn giờ áp dụng"
                          format="HH:mm"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    name="duration"
                    label="Thời lượng"
                  >
                    <Input placeholder="Ví dụ: 2 giờ, 5 tiếng, Cả ngày..." />
                  </Form.Item>

                  <Form.Item
                    name="reason"
                    label="Lý do"
                  >
                    <TextArea
                      rows={4}
                      placeholder="Nhập lý do cúp điện/nước..."
                    />
                  </Form.Item>
                </>
              )}

              {(notificationType === 'holiday' || notificationType === 'lunar') && (
                <>
                  <Form.Item
                    name="holidayName"
                    label="Tên kỳ nghỉ lễ/tết"
                  >
                    <Input placeholder="Ví dụ: Lễ Quốc Khánh, Tết Nguyên Đán..." />
                  </Form.Item>

                  <Form.Item
                    name="holidayRange"
                    label="Thời gian nghỉ lễ/tết"
                  >
                    <RangePicker style={{ width: '100%' }} />
                  </Form.Item>

                  <Form.Item
                    name="returnDate"
                    label="Ngày trở lại làm việc"
                  >
                    <DatePicker style={{ width: '100%' }} />
                  </Form.Item>
                </>
              )}

              <Form.Item
                name="template"
                label="Nội dung tùy chỉnh (tùy chọn)"
                getValueFromEvent={value => value}
              >
                <Button onClick={() => setShowHtml(!showHtml)} style={{ marginBottom: 8 }}>
                  {showHtml ? 'Quay lại soạn thảo' : 'Xem/chỉnh HTML'}
                </Button>
                {showHtml ? (
                  <Input.TextArea
                    rows={10}
                    value={templateValue}
                    onChange={e => {
                      setTemplateValue(e.target.value);
                      form.setFieldsValue({ template: e.target.value });
                    }}
                  />
                ) : (
                  <ReactQuill
                    theme="snow"
                    placeholder="Nhập nội dung thông báo chi tiết (hỗ trợ HTML)..."
                    style={{ minHeight: 150 }}
                    modules={quillModules}
                    value={templateValue}
                    onChange={value => {
                      setTemplateValue(value);
                      form.setFieldsValue({ template: value });
                    }}
                  />
                )}
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  icon={<SendOutlined />}
                >
                  Gửi thông báo
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </TabPane>

        <TabPane
          tab={<span><HistoryOutlined /> Lịch sử thông báo</span>}
          key="history"
        >
          <Card>
            <Table
              columns={columns}
              dataSource={sentNotifications}
              rowKey="NotificationID"
              loading={historyLoading}
              pagination={{
                current: page,
                pageSize: 10,
                total: total,
                onChange: handlePageChange
              }}
              scroll={{ x: 1000 }}
            />
          </Card>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default Notifications; 